// ─────────────────────────────────────────────────────────────────────────────
//  ChallanSettlement.constants.js
//  All static data, enums, and configuration for the Challan Settlement screen.
//  No logic here — pure data only.
// ─────────────────────────────────────────────────────────────────────────────

import {
    accentLightColor,
    blueBlackShade,
    blueishWhiteColor,
    blueWhiteShade,
    challanModalBlue,
    challanModalBlueDark,
    challanSvgCancelCircleBg,
    challanSvgEditAccentStroke,
    challanTextMuted3,
    grayShade,
    slightOrange,
    slightRed,
    tealFadeBg,
    tealMidLight,
    validationModalBackdropColor,
    validationModalBlueLightColor,
    validationModalErrBorderColor,
    validationModalOkBorderColor,
    validationModalWarnBorderColor,
    validationModalWarnLightColor,
    white,
    whiteLightShade,
} from "../../../config/ColorObj";

//Commented By Tejas 06-06-2026 As Current This constants are not used but in future it would be needs as per akash sir. 
// /** Expected total payment amount for this challan */
// export const EXPECTED_AMOUNT = 469;

/** Column definitions for the Stock Reconciliation table */
export const STOCK_TABLE_COLUMNS = [
    { label: "#", width: 30 },
    { label: "Product / SKU", width: 70 },
    { label: "Challan qty", width: 70, align: "right" },
    { label: "In qty", width: 50, align: "right" },
    { label: "Out qty", width: 50, align: "right" },
    { label: "Bill qty", width: 50, align: "right" },
    { label: "Rate (₹)", width: 50, align: "right" },
    { label: "Sys. expected", width: 65, align: "right" },
    {
        label: "Physical return",
        width: 80,
        align: "center",
        sub: "settler enters",
    },
    { label: "Difference", width: 50, align: "right" },
    { label: "Sell %", width: 90, align: "right" },
    { label: "Details", width: 30, align: "center" },
];


//Commented By Tejas 06-06-2026 As Current This constants are not used but in future it would be needs as per akash sir. 
/** Payment modes collected by the driver */
// export const PAYMENT_MODES = [
//     {
//         id: "cash",
//         label: "Cash",
//         sub: "Notes & coins physically counted",
//     },
//     {
//         id: "upi",
//         label: "UPI / digital",
//         sub: "PhonePe · GPay · IMPS · QR",
//     },
//     {
//         id: "cheque",
//         label: "Cheque (cleared)",
//         sub: "Only cheques cleared by admin count",
//     },
// ];

/** Outstanding dues data */
// export const DUES_LIST = [
//     {
//         bill: "Bill #1042 — Patel Store",
//         issued: "28 Jan 2026",
//         amt: "₹800",
//         age: "53 days overdue",
//     },
//     {
//         bill: "Bill #1061 — Mehta Kirana",
//         issued: "10 Mar 2026",
//         amt: "₹400",
//         age: "41 days overdue",
//     },
// ];



// ─── Default steps (override via prop) ───────────────────────────────────────

export const DEFAULT_STEPS = [
    {
        id: 1,
        delay: 1800,
        type: "ok",
        name: "Challan details",
        description:
            "Checking driver acknowledgement, settler sign-off."
    },
    {
        id: 2,
        delay: 2200,
        type: "ok",
        name: "Stock details",
        description:
            "Verifying physical return counts, SKU totals, sell-through % and logged discrepancy reasons against challan quantities.",
    },
];

export const validationModalStyleconstT = {
    blue: challanModalBlue,
    blueDark: challanModalBlueDark,
    blueLight: validationModalBlueLightColor,
    ok: tealMidLight,
    okLight: tealFadeBg,
    warn: slightOrange,
    warnLight: validationModalWarnLightColor,
    err: slightRed,
    errLight: challanSvgCancelCircleBg,
    ink1: blueBlackShade,
    ink2: blueWhiteShade,
    ink3: grayShade,
    ink4: challanTextMuted3,
    border: whiteLightShade,
    bg: blueishWhiteColor,
    surface: white,
    lineIdle: whiteLightShade,
    font: "'DM Sans', system-ui, sans-serif",
    mono: "'DM Mono', monospace",
};

export const validationStyles = {
    banner: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "10px 14px",
        borderRadius: 8,
        width: "100%",
        boxSizing: "border-box",
        fontSize: 13,
        fontWeight: 500,
    },
    backdrop: {
        position: "fixed",
        inset: 0,
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: validationModalBackdropColor,
        backdropFilter: "blur(3px)",
        animation: "v-backdrop 0.2s ease",
        fontFamily: validationModalStyleconstT.font,
    },
    popup: {
        background: validationModalStyleconstT.surface,
        borderRadius: 16,
        width: "100%",
        maxWidth: 540,
        boxShadow: "0 20px 60px rgba(0,0,0,0.18),0 4px 16px rgba(0,0,0,0.08)",
        overflow: "hidden",
        animation: "v-popup 0.28s cubic-bezier(0.22,1,0.36,1)",
        maxHeight: "92vh",
        display: "flex",
        flexDirection: "column",
    },
    header: {
        display: "flex",
        alignItems: "flex-start",
        gap: 14,
        padding: "22px 24px 18px",
        borderBottom: `1px solid ${validationModalStyleconstT.border}`,
        background: `linear-gradient(135deg,${validationModalStyleconstT.blueLight} 0%,${validationModalStyleconstT.surface} 100%)`,
    },
    headerIcon: {
        width: 40,
        height: 40,
        borderRadius: 10,
        background: validationModalStyleconstT.blue,
        color: white,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        boxShadow: `0 2px 8px ${validationModalStyleconstT.blue}44`,
    },
    headerTitle: {
        fontSize: 16,
        fontWeight: 700,
        color: validationModalStyleconstT.ink1,
        lineHeight: 1.3,
        marginBottom: 3,
    },
    headerSub: { fontSize: 13, color: validationModalStyleconstT.ink3, lineHeight: 1.45 },
    metaStrip: {
        display: "flex",
        borderBottom: `1px solid ${validationModalStyleconstT.border}`,
        background: validationModalStyleconstT.bg,
    },
    metaCell: {
        flex: 1,
        padding: "10px 18px",
        display: "flex",
        flexDirection: "column",
        gap: 2,
    },
    metaLabel: {
        fontSize: 10,
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        color: validationModalStyleconstT.ink4,
    },
    metaValue: {
        fontSize: 13,
        fontWeight: 600,
        color: validationModalStyleconstT.ink2,
        fontFamily: validationModalStyleconstT.mono,
    },
    stepsWrap: { padding: "20px 24px 4px", overflowY: "auto", flex: 1 },
    vStep: { display: "flex", gap: 14 },
    stepTrack: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexShrink: 0,
        width: 24,
    },
    stepLine: {
        width: 2,
        flex: 1,
        minHeight: 24,
        marginTop: 4,
        borderRadius: 2,
        transition: "background 0.4s ease",
    },
    stepContent: { flex: 1, paddingBottom: 20 },
    stepName: { fontSize: 14, fontWeight: 600, color: validationModalStyleconstT.ink1, marginBottom: 5 },
    stepDesc: { fontSize: 12.5, color: validationModalStyleconstT.ink3, lineHeight: 1.55 },
    dotBase: {
        width: 24,
        height: 24,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        transition: "all 0.3s ease",
    },
    dotIdle: { background: validationModalStyleconstT.bg, border: `2px solid ${validationModalStyleconstT.border}` },
    dotRunning: {
        width: 24,
        height: 24,
        borderRadius: "50%",
        background: validationModalStyleconstT.blueLight,
        color: validationModalStyleconstT.blue,
        border: `2px solid ${validationModalStyleconstT.blue}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    dotOk: { background: validationModalStyleconstT.okLight, color: validationModalStyleconstT.ok, border: `2px solid ${validationModalStyleconstT.ok}` },
    dotWarn: {
        background: validationModalStyleconstT.warnLight,
        color: validationModalStyleconstT.warn,
        border: `2px solid ${validationModalStyleconstT.warn}`,
    },
    dotErr: {
        background: validationModalStyleconstT.errLight,
        color: validationModalStyleconstT.err,
        border: `2px solid ${validationModalStyleconstT.err}`,
    },
    stepErrNote: {
        display: "flex",
        alignItems: "flex-start",
        gap: 7,
        marginTop: 8,
        padding: "9px 12px",
        borderRadius: 8,
        background: validationModalStyleconstT.errLight,
        border: `1px solid ${validationModalErrBorderColor}`,
        color: validationModalStyleconstT.err,
        fontSize: 12,
        lineHeight: 1.55,
        fontWeight: 500,
    },
    bannerRunning: {
        background: accentLightColor,
        color: validationModalStyleconstT.blue,
        border: `1px solid ${challanSvgEditAccentStroke}`,
    },
    bannerOk: {
        background: validationModalStyleconstT.okLight,
        color: validationModalStyleconstT.ok,
        border: `1px solid ${validationModalOkBorderColor}`,
    },
    bannerWarn: {
        background: validationModalStyleconstT.warnLight,
        color: validationModalStyleconstT.warn,
        border: `1px solid ${validationModalWarnBorderColor}`,
    },
    bannerErr: {
        background: validationModalStyleconstT.errLight,
        color: validationModalStyleconstT.err,
        border: `1px solid ${validationModalErrBorderColor}`,
    },
    pulseDot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: validationModalStyleconstT.blue,
        display: "inline-block",
        animation: "v-pulse 1.1s ease infinite",
        flexShrink: 0,
    },
    footer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 24px",
        borderTop: `1px solid ${validationModalStyleconstT.border}`,
        background: validationModalStyleconstT.bg,
        gap: 12,
        flexWrap: "wrap",
    },
    footerNote: { fontSize: 12, color: validationModalStyleconstT.ink4, fontStyle: "italic", flex: 1 },
    footerBtns: { display: "flex", gap: 8, alignItems: "center" },
    backBtn: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 13,
        fontWeight: 600,
        padding: "8px 16px",
        borderRadius: 8,
        border: `1px solid ${validationModalStyleconstT.border}`,
        background: validationModalStyleconstT.surface,
        color: validationModalStyleconstT.ink2,
        cursor: "pointer",
        fontFamily: validationModalStyleconstT.font,
    },
    saveBtn: {
        display: "inline-flex",
        alignItems: "center",
        gap: 7,
        fontSize: 13,
        fontWeight: 700,
        padding: "8px 18px",
        borderRadius: 8,
        border: "none",
        background: `linear-gradient(135deg,${validationModalStyleconstT.blue},${validationModalStyleconstT.blueDark})`,
        color: white,
        cursor: "pointer",
        fontFamily: validationModalStyleconstT.font,
        boxShadow: `0 2px 8px ${validationModalStyleconstT.blue}55`,
        animation: "v-fadein 0.3s ease",
    },
};

export const GLOBAL_CSS_VALIDATION = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
@keyframes v-spin     { to { transform: rotate(360deg); } }
@keyframes v-fadein   { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
@keyframes v-pulse    { 0%,100%{opacity:1;transform:scale(1);} 50%{opacity:.5;transform:scale(.85);} }
@keyframes v-backdrop { from{opacity:0;} to{opacity:1;} }
@keyframes v-popup    { from{opacity:0;transform:translateY(20px) scale(.97);} to{opacity:1;transform:translateY(0) scale(1);} }
@keyframes v-result   { from{opacity:0;transform:translateY(-4px);max-height:0;padding:0 12px;} to{opacity:1;transform:translateY(0);max-height:160px;} }
`;

